<template>
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Default</h4>
          <ul class="nav nav-tabs mb-4" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code-tab"
                data-bs-toggle="tab"
                data-bs-target="#code-tab-pane"
                type="button"
                role="tab"
                aria-controls="code-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="preview-tab-pane"
              role="tabpanel"
              aria-labelledby="preview-tab"
              tabindex="0"
            >
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar" style="width: 0%"></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar" style="width: 25%"></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar" style="width: 50%"></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar" style="width: 75%"></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar" style="width: 100%"></div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code-tab-pane"
              role="tabpanel"
              aria-labelledby="code-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode">
&lt;div class="progress mb-3" role="progressbar" aria-label="Basic example" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar" style="width: 0%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Basic example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar" style="width: 25%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Basic example" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar" style="width: 50%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar" style="width: 75%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Basic example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar" style="width: 100%"&gt;&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Heigh</h4>
          <ul class="nav nav-tabs mb-4" id="myTab2" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview2-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview2-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview2-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code2-tab"
                data-bs-toggle="tab"
                data-bs-target="#code2-tab-pane"
                type="button"
                role="tab"
                aria-controls="code2-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent2">
            <div
              class="tab-pane fade show active"
              id="preview2-tab-pane"
              role="tabpanel"
              aria-labelledby="preview2-tab"
              tabindex="0"
            >
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Example 1px high"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
                style="height: 1px"
              >
                <div class="progress-bar" style="width: 25%"></div>
              </div>
              <div
                class="progress"
                role="progressbar"
                aria-label="Example 20px high"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
                style="height: 20px"
              >
                <div class="progress-bar" style="width: 25%"></div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code2-tab-pane"
              role="tabpanel"
              aria-labelledby="code2-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode2"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode2">
&lt;div class="progress mb-3" role="progressbar" aria-label="Example 1px high" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 1px"&gt;
&lt;div class="progress-bar" style="width: 25%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress" role="progressbar" aria-label="Example 20px high" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 20px"&gt;
&lt;div class="progress-bar" style="width: 25%"&gt;&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Labels</h4>
          <ul class="nav nav-tabs mb-4" id="myTab3" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview3-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview3-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview3-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code3-tab"
                data-bs-toggle="tab"
                data-bs-target="#code3-tab-pane"
                type="button"
                role="tab"
                aria-controls="code3-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent3">
            <div
              class="tab-pane fade show active"
              id="preview3-tab-pane"
              role="tabpanel"
              aria-labelledby="preview3-tab"
              tabindex="0"
            >
              <div
                class="progress"
                role="progressbar"
                aria-label="Example with label"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar" style="width: 25%">25%</div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code3-tab-pane"
              role="tabpanel"
              aria-labelledby="code3-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode3"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode3">
&lt;div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar" style="width: 25%"&gt;25%&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Labels Text</h4>
          <ul class="nav nav-tabs mb-4" id="myTab4" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview4-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview4-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview4-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code4-tab"
                data-bs-toggle="tab"
                data-bs-target="#code4-tab-pane"
                type="button"
                role="tab"
                aria-controls="code4-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent4">
            <div
              class="tab-pane fade show active"
              id="preview4-tab-pane"
              role="tabpanel"
              aria-labelledby="preview4-tab"
              tabindex="0"
            >
              <div
                class="progress"
                role="progressbar"
                aria-label="Example with label"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar overflow-visible text-dark"
                  style="width: 10%"
                >
                  Long label text for the progress bar, set to a dark color
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code4-tab-pane"
              role="tabpanel"
              aria-labelledby="code4-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode4"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode4">
&lt;div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar overflow-visible text-dark" style="width: 10%"&gt;Long label text for the progress bar, set to a dark color&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Backgrounds</h4>
          <ul class="nav nav-tabs mb-4" id="myTab5" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview5-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview5-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview5-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code5-tab"
                data-bs-toggle="tab"
                data-bs-target="#code5-tab-pane"
                type="button"
                role="tab"
                aria-controls="code5-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent5">
            <div
              class="tab-pane fade show active"
              id="preview5-tab-pane"
              role="tabpanel"
              aria-labelledby="preview5-tab"
              tabindex="0"
            >
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Success example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar bg-success" style="width: 25%"></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Info example"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar bg-info" style="width: 50%"></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Warning example"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar bg-warning" style="width: 75%"></div>
              </div>
              <div
                class="progress mb-0"
                role="progressbar"
                aria-label="Danger example"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar bg-danger" style="width: 100%"></div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code5-tab-pane"
              role="tabpanel"
              aria-labelledby="code5-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode5"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode5">
&lt;div class="progress mb-3" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-success" style="width: 25%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Info example" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-info" style="width: 50%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Warning example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-warning" style="width: 75%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-0" role="progressbar" aria-label="Danger example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-danger" style="width: 100%"&gt;&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Backgrounds Label</h4>
          <ul class="nav nav-tabs mb-4" id="myTab6" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview6-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview6-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview6-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code6-tab"
                data-bs-toggle="tab"
                data-bs-target="#code6-tab-pane"
                type="button"
                role="tab"
                aria-controls="code6-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent6">
            <div
              class="tab-pane fade show active"
              id="preview6-tab-pane"
              role="tabpanel"
              aria-labelledby="preview6-tab"
              tabindex="0"
            >
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Success example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar bg-success" style="width: 25%">
                  25%
                </div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Info example"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar bg-info text-dark" style="width: 50%">
                  50%
                </div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Warning example"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar bg-warning text-dark"
                  style="width: 75%"
                >
                  75%
                </div>
              </div>
              <div
                class="progress"
                role="progressbar"
                aria-label="Danger example"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar bg-danger" style="width: 100%">
                  100%
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code6-tab-pane"
              role="tabpanel"
              aria-labelledby="code6-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode6"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode6">
&lt;div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-success" style="width: 25%"&gt;25%&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress" role="progressbar" aria-label="Info example" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-info text-dark" style="width: 50%"&gt;50%&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress" role="progressbar" aria-label="Warning example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-warning text-dark" style="width: 75%"&gt;75%&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress" role="progressbar" aria-label="Danger example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar bg-danger" style="width: 100%"&gt;100%&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Multiple bars</h4>
          <ul class="nav nav-tabs mb-4" id="myTab7" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview7-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview7-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview7-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code7-tab"
                data-bs-toggle="tab"
                data-bs-target="#code7-tab-pane"
                type="button"
                role="tab"
                aria-controls="code7-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent7">
            <div
              class="tab-pane fade show active"
              id="preview7-tab-pane"
              role="tabpanel"
              aria-labelledby="preview7-tab"
              tabindex="0"
            >
              <div class="progress-stacked">
                <div
                  class="progress"
                  role="progressbar"
                  aria-label="Segment one"
                  aria-valuenow="15"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 15%"
                >
                  <div class="progress-bar"></div>
                </div>
                <div
                  class="progress"
                  role="progressbar"
                  aria-label="Segment two"
                  aria-valuenow="30"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 30%"
                >
                  <div class="progress-bar bg-success"></div>
                </div>
                <div
                  class="progress"
                  role="progressbar"
                  aria-label="Segment three"
                  aria-valuenow="20"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 20%"
                >
                  <div class="progress-bar bg-info"></div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code7-tab-pane"
              role="tabpanel"
              aria-labelledby="code7-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode7"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode7">
&lt;div class="progress-stacked"&gt;
&lt;div class="progress" role="progressbar" aria-label="Segment one" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100" style="width: 15%"&gt;
&lt;div class="progress-bar"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress" role="progressbar" aria-label="Segment two" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style="width: 30%"&gt;
&lt;div class="progress-bar bg-success"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress" role="progressbar" aria-label="Segment three" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"&gt;
&lt;div class="progress-bar bg-info"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Striped</h4>
          <ul class="nav nav-tabs mb-4" id="myTab8" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview8-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview8-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview8-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code8-tab"
                data-bs-toggle="tab"
                data-bs-target="#code8-tab-pane"
                type="button"
                role="tab"
                aria-controls="code8-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent8">
            <div
              class="tab-pane fade show active"
              id="preview8-tab-pane"
              role="tabpanel"
              aria-labelledby="preview8-tab"
              tabindex="0"
            >
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Default striped example"
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar progress-bar-striped"
                  style="width: 10%"
                ></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Success striped example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar progress-bar-striped bg-success"
                  style="width: 25%"
                ></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Info striped example"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar progress-bar-striped bg-info"
                  style="width: 50%"
                ></div>
              </div>
              <div
                class="progress mb-3"
                role="progressbar"
                aria-label="Warning striped example"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar progress-bar-striped bg-warning"
                  style="width: 75%"
                ></div>
              </div>
              <div
                class="progress mb-0"
                role="progressbar"
                aria-label="Danger striped example"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar progress-bar-striped bg-danger"
                  style="width: 100%"
                ></div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code8-tab-pane"
              role="tabpanel"
              aria-labelledby="code8-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode8"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode8">
&lt;div class="progress mb-3" role="progressbar" aria-label="Default striped example" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar progress-bar-striped" style="width: 10%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Success striped example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar progress-bar-striped bg-success" style="width: 25%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Info striped example" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar progress-bar-striped bg-info" style="width: 50%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-3" role="progressbar" aria-label="Warning striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar progress-bar-striped bg-warning" style="width: 75%"&gt;&lt;/div&gt;
&lt;/div&gt;
&lt;div class="progress mb-0" role="progressbar" aria-label="Danger striped example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar progress-bar-striped bg-danger" style="width: 100%"&gt;&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Progressbar Animated stripes</h4>
          <ul class="nav nav-tabs mb-4" id="myTab9" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview9-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview9-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview9-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code9-tab"
                data-bs-toggle="tab"
                data-bs-target="#code9-tab-pane"
                type="button"
                role="tab"
                aria-controls="code9-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent9">
            <div
              class="tab-pane fade show active"
              id="preview9-tab-pane"
              role="tabpanel"
              aria-labelledby="preview9-tab"
              tabindex="0"
            >
              <div
                class="progress"
                role="progressbar"
                aria-label="Animated striped example"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  class="progress-bar progress-bar-striped progress-bar-animated"
                  style="width: 75%"
                ></div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code9-tab-pane"
              role="tabpanel"
              aria-labelledby="code9-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode9"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode9">
&lt;div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"&gt;
&lt;div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 75%"&gt;&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import Prism from "prismjs";
import "prismjs/themes/prism.min.css";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Progress",
  setup() {
    onMounted(() => {
      Prism.highlightAll();
    });
  },
});
</script>
